import { border, flexbox, layout, space } from 'styled-system';
import styled from '@marvelapp/styled';
export const DashboardHeaderElement = styled.div `
  ${border};
  ${flexbox};
  ${layout};
  ${space};
  display: flex;
`;
